import { AUTH_ACTIONS } from "assets/scripts/domain/auth/authActions";
import { push } from "react-router-redux";
export default function logoutCheck(error, dispatch) {
    if (error != null && error.response != null && error.response.status === 401) {
        dispatch({ type: AUTH_ACTIONS.LOGOUT, payload: false });
        dispatch(push("/public"));
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/logoutCheck.ts